import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { SubscriptionPlan } from '@vi-iot/client';

import {
  DIAGNOSTICS_CONNECTION_STATUS,
  InstallationDetailsStore,
  Platform,
  RemoteConfigStore,
  RemoteDiagnosticsStore,
} from '@store';
import { PillType } from '../../../shared/components/pill/pill.model';

@Component({
  selector: 'app-diagnostics-connection-status',
  templateUrl: './diagnostics-connection-status.component.html',
  styleUrls: ['./diagnostics-connection-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiagnosticsConnectionStatusComponent {
  readonly diagnosticsConnectionStatus = DIAGNOSTICS_CONNECTION_STATUS;
  readonly bookingPlans = SubscriptionPlan;
  readonly platform = Platform;
  readonly pillType = PillType;

  @Input() connectionStatus: DIAGNOSTICS_CONNECTION_STATUS;
  @Input() gatewaySerial: string;
  @Input() isDiagnosticsAvailable: boolean;
  @Input() installationPackage: SubscriptionPlan;
  @Input() devicePlatform: Platform;

  constructor(
    public remoteDiagnosticsStore: RemoteDiagnosticsStore,
    public installationDetailsStore: InstallationDetailsStore,
    public remoteConfigStore: RemoteConfigStore
  ) {}
}
